//
//
//
//
//
//

import { mapGetters } from 'vuex'

import Announcement from './debut-stream'
import StreamAnnouncement from './stream-announcement'

// const shouldShowAnnouncement = () => Date.now() >= 1692392400000

export default {
    components: {
        announcementContent: Announcement,
        streamAnnouncement: StreamAnnouncement,
    },

    data() {
        return {
            // showAnnouncement: shouldShowAnnouncement(),
            showAnnouncement: true,
        }
    },

    // mounted() {
    //     this.$listenFor('TICK_MIN', () => {
    //         this.showAnnouncement = shouldShowAnnouncement()
    //     })
    // },

    computed: {
        ...mapGetters(['game']),
        hasStreamAnnouncement() {
            return !!this.$store.getters.streamAnnouncement
        },
    },
}
